<template>
  <div>
    <v-card class=" pt-10">
      <!-- <ul>
        <li
          v-for="todo in todos"
          :key="todo.id"
        >
          <span>{{ todo.text }}</span>
        </li>
      </ul>
      <div v-if="someTodo">
        <span>{{ someTodo.id +' '+someTodo.text }}</span>
      </div> -->
      <v-card-text>
        <center class=" mb-5">
          <section v-if="displayProcess">
            <h1>{{ processMessage }}</h1>
          </section>
          <section v-else-if="displayResult">
            <v-icon
              :color="resultIconColor"
              size="150"
            >
              {{ resultIcon }}
            </v-icon>
            <section class="ex-large-text">
              {{ resultMessage }}
            </section>
          </section>
          <section v-else-if="displayQrcode">
            <vue-qrcode
              v-if="initQrCode"
              :value="qrcodeString"
              :options="{ width: 200 }"
            ></vue-qrcode>
          </section>
        </center>
        <basic-user-info
          class="pb-10"
          :user-record="internalUserData"
        ></basic-user-info>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { ref, onMounted, nextTick, onUnmounted, computed } from 'vue'
import sha512 from 'crypto-js/sha512'
import { collection, doc } from 'firebase/firestore'

// import { useCollection, useDocument } from 'vuefire'
import moment from '@/utils/moment'
import { useStore } from '@/store'
import BasicUserInfo from '@/views/pages/components/BasicUserInfo'
import { getUserData } from '@/utils/auth'
import { getItem } from '@/api/user'

// import getDatabase from '@/firebase/index'

const initQrCode = ref(false)

// console.log('getDatabase', getDatabase)
// const db = getDatabase()
onMounted(async () => {
  try {
    // const docRef = collection(db, 'UserRecord')
    // const docSnap = await getDoc(docRef)
    // console.log(docSnap)

    // const docRef = await addDoc(collection(db, 'public/course/1/'), {
    //   first: 'Ada',
    //   last: 'Lovelace',
    //   born: 1815,
    // })
    // console.log('Document written with ID: ', docRef.id)
  } catch (e) {
    console.error('Error adding document: ', e)
  }
})

const displayQrcode = ref(false)
const displayProcess = ref(false)
const processMessage = ref('Assigning Locker Key Please Wait...')

const displayResult = ref(false)

const resultIcon = ref('mdi-close-circle')
const resultIconColor = ref('#F00')
const resultMessage = ref('No Course Today')

function showErrorResult() {
  displayResult.value = true
  resultIcon.value = 'mdi-close-circle'
  resultIconColor.value = '#F24726'
  resultMessage.value = 'No Course Today'
}
function showOkResult() {
  displayResult.value = true
  resultIcon.value = 'mdi-check'
  resultIconColor.value = '#8FD14F'
  resultMessage.value = `${moment().format('HH:mm')}`
}

onMounted(() => {
  // showOkResult()
  displayQrcode.value = true
})

const checkinProcessMessage = ref('Assigning Locker Key Please Wait...')
const checkoutProcessMessage = ref('Please Return Locker Key To Reception')

const internalUserData = ref({
  id: -1,
  fullName: '',
  gender: '',
  userNo: '',
})
const userRecord = getUserData()
const qrcodeString = ref('-1')
console.log('profile userRecord', userRecord)

// const todos = useCollection(collection(db, 'todos'))
// const someTodo = computed(() => { useDocument(doc(collection(db, 'todos'), internalUserData.value.id.toString())) })

function getQrcodeString() {
  const obj = {
    id: internalUserData.value.id,
    timestamp: moment().valueOf(),
    type: 'student',
  }
  const objString = JSON.stringify(obj)
  initQrCode.value = true

  return objString
}
if (userRecord) {
  getItem(userRecord.userToken.userRecordID).then(response => {
    console.log('profile get userRecord', response)
    if (response.data.record) {
      internalUserData.value = response.data.record
      qrcodeString.value = getQrcodeString()

      // todos = useCollection(collection(db, 'todos'))

      // someTodo.value = useDocument(doc(collection(db, 'todos'), '1')).value
      // console.log('someTodo', someTodo)
      // console.log('someTodo2', useDocument(doc(collection(db, 'todos'), internalUserData.value.id.toString())))
    }
  })
}
let interval = null

onMounted(() => {
  qrcodeString.value = getQrcodeString()

  // refresh the qrcode every 60 seconds
  interval = setInterval(() => {
    nextTick(() => {
      if (displayQrcode.value) {
        qrcodeString.value = getQrcodeString()
      }
      console.log('trigger interval')
    })
  }, 30000)
})
onUnmounted(() => {
  console.log('onUnmounted', interval)
  clearInterval(interval)
})
</script>
<style scoped>
.ex-large-text{
  font-size: 48px;
}
</style>
